// extracted by mini-css-extract-plugin
export default {"root":"DisclaimerModal_root__knMT9","title":"DisclaimerModal_title__8e94y"};